<template>
  <div class="section">
    <div class="">
      <!-- Header -->
      <div class="level mb-5">
        <div class="level-left">
          <div class="level-item">
            <div>
              <h1 class="title is-3">Orders Dashboard</h1>
              
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <button class="button is-light is-small" @click="clearFilters">
              <span>Reset Filters</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="orders_loading" class="box has-text-centered">
        <progress class="progress is-large is-info" max="100">Loading...</progress>
      </div>

      <!-- Filters -->
      <div v-else class="box mb-5">
        <p class="heading has-text-grey mb-3">Filters</p>
        <div class="columns is-multiline">
          <div class="column is-4">
            <label class="label is-small">Range</label>
            <div class="tags">
              <span
                v-for="range in uniqueRanges"
                :key="range"
                class="tag is-medium is-clickable"
                :class="filterRanges.includes(range) ? 'is-info' : 'is-light'"
                @click="toggleFilter('filterRanges', range)"
              >
                {{ range }}
              </span>
            </div>
          </div>

          <div class="column is-4">
            <label class="label is-small">Order Type</label>
            <div class="tags">
              <span
                v-for="order_type in uniqueorder_types"
                :key="order_type"
                class="tag is-medium is-clickable"
                :class="filterorder_types.includes(order_type) ? 'is-info' : 'is-light'"
                @click="toggleFilter('filterorder_types', order_type)"
              >
                {{ order_type }}
              </span>
            </div>
          </div>

          <div class="column is-4">
            <label class="label is-small">Makeup Location</label>
            <div class="tags">
              <span
                v-for="location in uniqueLocations"
                :key="location"
                class="tag is-medium is-clickable"
                :class="filterLocations.includes(location) ? 'is-info' : 'is-light'"
                @click="toggleFilter('filterLocations', location)"
              >
                {{ location }}
              </span>
            </div>
          </div>

          <div class="column is-4">
            <p class="label is-small">Print Location</p>
            <div class="tags">
              <span
                v-for="location in uniquePrintLocations"
                :key="location"
                class="tag is-medium is-clickable"
                :class="filterPrintLocations.includes(location) ? 'is-info' : 'is-light'"
                @click="toggleFilter('filterPrintLocations', location)"
              >
                {{ location }}
              </span>
            </div>
          </div>

          <div class="column is-4">
            <p class="label is-small">Artwork Completed</p>
            <div class="tags">
              <span
                v-for="artwork in uniqueArtworks"
                :key="artwork"
                class="tag is-medium is-clickable"
                :class="filterArtworks.includes(artwork) ? 'is-info' : 'is-light'"
                @click="toggleFilter('filterArtworks', artwork)"
              >
                {{ artwork }}
              </span>
            </div>
          </div>

          <div class="column is-4">
            <p class="label is-small">Ready for Makeup</p>
            <div class="tags">
              <span
                v-for="makeup in uniqueMakeups"
                :key="makeup"
                class="tag is-medium is-clickable"
                :class="filterMakeups.includes(makeup) ? 'is-info' : 'is-light'"
                @click="toggleFilter('filterMakeups', makeup)"
              >
                {{ makeup }}
              </span>
            </div>
          </div>
        </div>
        <p class="help has-text-grey">
          Showing <strong>{{ filteredOrders.length }}</strong> of <strong>{{ orders.length }}</strong> orders
          <span v-if="activeFilterCount > 0"> — {{ activeFilterCount }} filter{{ activeFilterCount > 1 ? 's' : '' }} active</span>
        </p>
      </div>

      <!-- Summary Cards -->
      <div v-if="!orders_loading" class="columns is-multiline mb-5">
        <div class="column is-2">
          <div class="box has-background-info-light">
            <p class="heading">Total Orders</p>
            <p class="title">{{ totalOrders }}</p>
          </div>
        </div>
        <div class="column is-2">
          <div class="box has-background-success-light">
            <p class="heading">Garments</p>
            <p class="title">{{ totalQty }}</p>
          </div>
        </div>
        <div class="column is-2">
          <div class="box has-background-warning-light">
            <p class="heading">Total Printed</p>
            <p class="title">{{ totalqty_printed }}</p>
          </div>
        </div>
        <div class="column is-2">
          <div class="box has-background-danger-light">
            <p class="heading">Total Trans</p>
            <p class="title">{{ totalqty_rolls }}</p>
          </div>
        </div>
        <div class="column is-2">
          <div class="box has-background-primary-light">
            <p class="heading">Total Cut</p>
            <p class="title">{{ totalqty_cut }}</p>
          </div>
        </div>
      </div>

      <!-- Orders Table -->
      <div v-if="!orders_loading" class="box mt-5">
        <div class="tabs is-toggle is-small mb-3">
          <ul>
            <li :class="{ 'is-active': activeTableTab === 'orders' }">
              <a @click.prevent="activeTableTab = 'orders'">Orders List</a>
            </li>
            <li :class="{ 'is-active': activeTableTab === 'region' }">
              <a @click.prevent="activeTableTab = 'region'">By Region</a>
            </li>
            <li :class="{ 'is-active': activeTableTab === 'printlocation' }">
              <a @click.prevent="activeTableTab = 'printlocation'">By Print Location</a>
            </li>
            <li :class="{ 'is-active': activeTableTab === 'workinprogress' }">
              <a @click.prevent="activeTableTab = 'workinprogress'">Work In Progress</a>
            </li>
            <li :class="{ 'is-active': activeTableTab === 'statistics' }">
              <a @click.prevent="activeTableTab = 'statistics'">Statistics</a>
            </li>
          </ul>
        </div>

        
        <div v-if="activeTableTab === 'orders'" class="table-container">
          <table class="table is-fullwidth is-striped is-hoverable is-size-7">
            <thead>
              <tr class="is-selected">
                <th>PO Number</th>
                <th>Client Name</th>
                <th>Region</th>
                <th>Range</th>
                <th>Garment Name</th>
                <th>Order Type</th>
                <th>Order Date</th>
                <th>Artwork</th>
                <th>Print Location</th>
                
                <th>Total</th>
                <th>Printed</th>
                <th>Trans</th>
                <th>Cut</th>
                <th>Makeup</th>
                <th>Received</th>
                <th>On Floor</th>
                <th>Off Floor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in filteredOrders" :key="order.ponumber">
                <td>
                  <span class="tag is-light">{{ order.ponumber }}</span>
                </td>
                <td>{{ order.clientname }}</td>
                <td>{{ order.Region || order.region }}</td>
                <td>{{ order.range }}</td>
                <td>{{ order.garmentname || order.garment_name }}</td>
                <td>{{ order.order_type }}</td>
                <td>{{ formatDate(order.orderdate) }}</td>
                <td>
                  <span
                    :class="{
                      'tag is-success': ((order.artwork || order.Artwork || '') + '').toLowerCase() === 'yes',
                      'tag is-warning': ((order.artwork || order.Artwork || '') + '').toLowerCase() === 'no',
                    }"
                  >
                    {{ order.artwork || order.Artwork }}
                  </span>
                </td>
                <td>{{ order.printlocation }}</td>
                
                <td>
                  <span class="tag is-info">{{ order.total_qty }}</span>
                </td>
                <td>
                  <span
                    :class="{
                      'tag is-success': order.qty_printed === order.total_qty,
                      'tag is-warning': order.qty_printed < order.total_qty,
                    }"
                  >
                    {{ order.qty_printed }}
                  </span>
                </td>
                <td>
                  <span
                    :class="{
                      'tag is-success': order.qty_rolls === order.total_qty,
                      'tag is-warning': order.qty_rolls < order.total_qty,
                    }"
                  >
                    {{ order.qty_rolls }}
                  </span>
                </td>
                <td>
                  <span
                    :class="{
                      'tag is-success': order.qty_cut === order.total_qty,
                      'tag is-warning': order.qty_cut < order.total_qty,
                    }"
                  >
                    {{ order.qty_cut }}
                  </span>
                </td>
                <td>
                  <span
                    :class="{
                      'tag is-success': ((order.makeup || order.Makeup || '') + '').toLowerCase() === 'yes',
                      'tag is-warning': ((order.makeup || order.Makeup || '') + '').toLowerCase() === 'no',
                    }"
                  >
                    {{ order.makeuplocation }}
                  </span>
                </td>
                <td>
                  <span
                    :class="{
                      'tag is-success': order.qty_received === order.total_qty,
                      'tag is-warning': order.qty_received < order.total_qty,
                    }"
                  >
                    {{ order.qty_received }}
                  </span>
                </td>
                <td>
                  <span
                    :class="{
                      'tag is-success': order.qty_on_factory_floor === order.total_qty,
                      'tag is-warning': order.qty_on_factory_floor < order.total_qty,
                    }"
                  >
                    {{ order.qty_on_factory_floor }}
                  </span>
                </td>
                <td>
                  <span
                    :class="{
                      'tag is-success': order.qty_off_factory_floor === order.total_qty,
                      'tag is-warning': order.qty_off_factory_floor < order.total_qty,
                    }"
                  >
                    {{ order.qty_off_factory_floor }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="activeTableTab === 'region'" class="table-container">
          <table class="table is-fullwidth is-striped is-hoverable is-size-7">
            <thead>
              <tr class="is-selected">
                <th>Region</th>
                <th>Orders</th>
                <th>Total</th>
                <th>Printed</th>
                <th>Trans</th>
                <th>Cut</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in regionBreakdown" :key="row.region">
                <td>{{ row.region }}</td>
                <td>{{ row.orders }}</td>
                <td><span class="tag is-info">{{ row.total_qty }}</span></td>
                <td>{{ row.qty_printed }}</td>
                <td>{{ row.qty_rolls }}</td>
                <td>{{ row.qty_cut }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="activeTableTab === 'printlocation'" class="table-container">
          <table class="table is-fullwidth is-striped is-hoverable is-size-7">
            <thead>
              <tr class="is-selected">
                <th>Print Location</th>
                <th>Orders</th>
                <th>Total</th>
                <th>Printed</th>
                <th>Trans</th>
                <th>Cut</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in printLocationBreakdown" :key="row.printlocation">
                <td>{{ row.printlocation }}</td>
                <td>{{ row.orders }}</td>
                <td><span class="tag is-info">{{ row.total_qty }}</span></td>
                <td>{{ row.qty_printed }}</td>
                <td>{{ row.qty_rolls }}</td>
                <td>{{ row.qty_cut }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="activeTableTab === 'workinprogress'" class="table-container">
          <table class="table is-fullwidth is-striped is-hoverable is-size-7">
            <thead>
              <tr class="is-selected">
                <th>Makeup Location</th>
                <th>Orders</th>
                <th>Sum of Garments</th>
                <th>Total Received</th>
                <th>Total On Factory Floor</th>
                <th>Total Off Factory Floor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in workInProgressBreakdown" :key="row.makeuplocation">
                <td>{{ row.makeuplocation }}</td>
                <td>{{ row.orders }}</td>
                <td><span class="tag is-info">{{ row.total_qty }}</span></td>
                <td>{{ row.qty_received }}</td>
                <td>{{ row.qty_on_factory_floor }}</td>
                <td>{{ row.qty_off_factory_floor }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="activeTableTab === 'statistics'" class="content">
          <div class="columns is-multiline">
            <div class="column is-6">
              <div class="box has-background-info-light">
                <p class="heading">All Orders</p>
                <p><strong>Total Orders:</strong> {{ statisticsTotalOrders }}</p>
                <p><strong>Sum of Total Garments:</strong> {{ statisticsTotalGarments }} </p>
              </div>
            </div>
            <div class="column is-6">
              <div class="box has-background-warning-light">
                <p class="heading">Waiting For Artwork</p>
                <p><strong>Total Orders:</strong> {{ waitingForArtworkOrders }}</p>
                <p><strong>Sum of Total Garments:</strong> {{ waitingForArtworkGarments }} ({{ waitingForArtworkGarmentsPercent }}%)</p>
              </div>
            </div>
            <div class="column is-6">
              <div class="box has-background-danger-light">
                <p class="heading">Artwork Complete but Awaiting Printing</p>
                <p><strong>Total Orders:</strong> {{ awaitingPrintingOrders }}</p>
                <p><strong>Sum of Total Garments:</strong> {{ awaitingPrintingGarments }} ({{ awaitingPrintingGarmentsPercent }}%)</p>
              </div>
            </div>
            <div class="column is-6">
              <div class="box has-background-primary-light">
                <p class="heading">Printing Complete but Awaiting Gerber Cutting</p>
                <p><strong>Total Orders:</strong> {{ awaitingGerberCuttingOrders }}</p>
                <p><strong>Sum of Total Garments:</strong> {{ awaitingGerberCuttingGarments }} ({{ awaitingGerberCuttingGarmentsPercent }}%)</p>
              </div>
            </div>
            <div class="column is-6">
              <div class="box has-background-success-light">
                <p class="heading">Gerber Cutting Complete</p>
                <p><strong>Total Orders:</strong> {{ gerberCuttingCompleteOrders }}</p>
                <p><strong>Sum of Total Garments:</strong> {{ gerberCuttingCompleteGarments }} ({{ gerberCuttingCompleteGarmentsPercent }}%)</p>
              </div>
            </div>
          </div>
        </div>

        <div v-if="activeTableTab === 'orders' && filteredOrders.length === 0" class="has-text-centered mt-5">
          <p class="subtitle is-5">No orders found matching your filters.</p>
        </div>
        <div v-if="activeTableTab === 'region' && regionBreakdown.length === 0" class="has-text-centered mt-5">
          <p class="subtitle is-5">No region totals available.</p>
        </div>
        <div v-if="activeTableTab === 'printlocation' && printLocationBreakdown.length === 0" class="has-text-centered mt-5">
          <p class="subtitle is-5">No print location totals available.</p>
        </div>
        <div v-if="activeTableTab === 'workinprogress' && workInProgressBreakdown.length === 0" class="has-text-centered mt-5">
          <p class="subtitle is-5">No work in progress totals available.</p>
        </div>
        <div v-if="activeTableTab === 'statistics' && filteredOrders.length === 0" class="has-text-centered mt-5">
          <p class="subtitle is-5">No statistics available for the current filters.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderService from '@/services/OrderService.js';

export default {
  name: 'Overview',
  data() {
    return {
      orders: [
        {
          ponumber: 'PO-001',
          clientname: 'Acme Corp',
          range: 'Jerseys',
          order_type: 'Standard',
          orderdate: '2026-03-15',
          makeuplocation: 'Warehouse A',
          printlocation: 'Printer 1',
          total_qty: 500,
          qty_printed: 500,
          qty_rolls: 480,
          qty_cut: 470,
        },
        {
          ponumber: 'PO-002',
          clientname: 'Tech Solutions',
          range: 'Leisurewear',
          order_type: 'Rush',
          orderdate: '2026-03-18',
          makeuplocation: 'Warehouse B',
          printlocation: 'Printer 2',
          total_qty: 1000,
          qty_printed: 850,
          qty_rolls: 820,
          qty_cut: 790,
        },
        {
          ponumber: 'PO-003',
          clientname: 'Global Traders',
          range: 'Socks',
          order_type: 'Standard',
          orderdate: '2026-03-20',
          makeuplocation: 'Warehouse A',
          printlocation: 'Printer 1',
          total_qty: 750,
          qty_printed: 750,
          qty_rolls: 735,
          qty_cut: 730,
        },
        {
          ponumber: 'PO-004',
          clientname: 'Acme Corp',
          range: 'Shorts',
          order_type: 'Express',
          orderdate: '2026-03-22',
          makeuplocation: 'Warehouse C',
          printlocation: 'Printer 3',
          total_qty: 250,
          qty_printed: 200,
          qty_rolls: 190,
          qty_cut: 185,
        },
      ],
      orders_loading: false,
      accessToken: null,
      client_id: null,
      range: null,
      start_date: null,
      end_date: null,
      filterRanges: [],
      filterorder_types: [],
      filterLocations: [],
      filterPrintLocations: [],
      filterArtworks: [],
      filterMakeups: [],
      activeTableTab: 'orders',
    };
  },
  created() {
    this.getAccessToken().then(() => {
      this.getOrders();
    });
  },
  methods: {
    async getAccessToken() {
      this.accessToken = await this.$auth.getTokenSilently();
    },
    async getOrders() {
      this.orders_loading = true;
      OrderService.getAggregatedOpenOrders(
        this.accessToken,
       
      ).then((orders) => {
        this.$set(this, 'orders', orders);
        this.orders_loading = false;
      });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    clearFilters() {
      this.filterRanges = [];
      this.filterorder_types = [];
      this.filterLocations = [];
      this.filterPrintLocations = [];
      this.filterArtworks = [];
      this.filterMakeups = [];
    },
    toggleFilter(filterKey, value) {
      const idx = this[filterKey].indexOf(value);
      if (idx === -1) {
        this[filterKey].push(value);
      } else {
        this[filterKey].splice(idx, 1);
      }
    },
    isArtworkFalse(order) {
      const rawArtwork = order.artwork ?? order.Artwork;

      if (typeof rawArtwork === 'boolean') {
        return rawArtwork === false;
      }

      const normalizedArtwork = (rawArtwork || '').toString().trim().toLowerCase();
      return ['false', 'no', 'n', '0'].includes(normalizedArtwork);
    },
    isArtworkTrue(order) {
      const rawArtwork = order.artwork ?? order.Artwork;

      if (typeof rawArtwork === 'boolean') {
        return rawArtwork === true;
      }

      const normalizedArtwork = (rawArtwork || '').toString().trim().toLowerCase();
      return ['true', 'yes', 'y', '1'].includes(normalizedArtwork);
    },
    isMakeupTrue(order) {
      const rawMakeup = order.makeup ?? order.Makeup;

      if (typeof rawMakeup === 'boolean') {
        return rawMakeup === true;
      }

      const normalizedMakeup = (rawMakeup || '').toString().trim().toLowerCase();
      return ['true', 'yes', 'y', '1'].includes(normalizedMakeup);
    },
  },
  computed: {
    uniqueRanges() {
      return [...new Set(this.orders.map((order) => order.range))].sort();
    },
    uniqueorder_types() {
      return [...new Set(this.orders.map((order) => order.order_type))].sort();
    },
    uniqueLocations() {
      return [...new Set(this.orders.map((order) => order.makeuplocation))].sort();
    },
    uniquePrintLocations() {
      return [...new Set(this.orders.map((order) => order.printlocation))].sort();
    },
    uniqueArtworks() {
      return [...new Set(
        this.orders
          .map((order) => (order.artwork || order.Artwork || '').toString().trim())
          .filter(Boolean)
          .map((value) => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase())
      )].sort();
    },
    uniqueMakeups() {
      return [...new Set(
        this.orders
          .map((order) => (order.makeup || order.Makeup || '').toString().trim())
          .filter(Boolean)
          .map((value) => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase())
      )].sort();
    },
    activeFilterCount() {
      return this.filterRanges.length + this.filterorder_types.length + this.filterLocations.length + this.filterPrintLocations.length + this.filterArtworks.length + this.filterMakeups.length;
    },
    totalOrders() {
      return this.filteredOrders.length;
    },
    totalQty() {
      return this.filteredOrders.reduce((sum, order) => sum + order.total_qty, 0);
    },
    totalqty_printed() {
      return this.filteredOrders.reduce((sum, order) => sum + order.qty_printed, 0);
    },
    totalqty_rolls() {
      return this.filteredOrders.reduce((sum, order) => sum + (order.qty_rolls || 0), 0);
    },
    totalqty_cut() {
      return this.filteredOrders.reduce((sum, order) => sum + (order.qty_cut || 0), 0);
    },
    statisticsTotalOrders() {
      return this.filteredOrders.length;
    },
    statisticsTotalGarments() {
      return this.filteredOrders.reduce((sum, order) => sum + (order.total_qty || 0), 0);
    },
    statisticsTotalGarmentsPercent() {
      return this.statisticsTotalGarments > 0 ? 100 : 0;
    },
    waitingForArtworkOrders() {
      return this.filteredOrders.filter((order) => this.isArtworkFalse(order)).length;
    },
    waitingForArtworkGarments() {
      return this.filteredOrders
        .filter((order) => this.isArtworkFalse(order))
        .reduce((sum, order) => sum + (order.total_qty || 0), 0);
    },
    waitingForArtworkGarmentsPercent() {
      if (!this.statisticsTotalGarments) {
        return 0;
      }

      return ((this.waitingForArtworkGarments / this.statisticsTotalGarments) * 100).toFixed(1);
    },
    awaitingPrintingOrders() {
      return this.filteredOrders.filter((order) => this.isArtworkTrue(order) && Number(order.qty_printed || 0) === 0).length;
    },
    awaitingPrintingGarments() {
      return this.filteredOrders
        .filter((order) => this.isArtworkTrue(order) && Number(order.qty_printed || 0) === 0)
        .reduce((sum, order) => sum + (order.total_qty || 0), 0);
    },
    awaitingPrintingGarmentsPercent() {
      if (!this.statisticsTotalGarments) {
        return 0;
      }

      return ((this.awaitingPrintingGarments / this.statisticsTotalGarments) * 100).toFixed(1);
    },
    awaitingGerberCuttingOrders() {
      return this.filteredOrders.filter((order) => Number(order.qty_printed || 0) === Number(order.total_qty || 0) && Number(order.qty_cut || 0) === 0).length;
    },
    awaitingGerberCuttingGarments() {
      return this.filteredOrders
        .filter((order) => Number(order.qty_printed || 0) === Number(order.total_qty || 0) && Number(order.qty_cut || 0) === 0)
        .reduce((sum, order) => sum + (order.total_qty || 0), 0);
    },
    awaitingGerberCuttingGarmentsPercent() {
      if (!this.statisticsTotalGarments) {
        return 0;
      }

      return ((this.awaitingGerberCuttingGarments / this.statisticsTotalGarments) * 100).toFixed(1);
    },
    gerberCuttingCompleteOrders() {
      return this.filteredOrders.filter((order) => Number(order.qty_cut || 0) >= Number(order.total_qty || 0)).length;
    },
    gerberCuttingCompleteGarments() {
      return this.filteredOrders
        .filter((order) => Number(order.qty_cut || 0) >= Number(order.total_qty || 0))
        .reduce((sum, order) => sum + (order.total_qty || 0), 0);
    },
    gerberCuttingCompleteGarmentsPercent() {
      if (!this.statisticsTotalGarments) {
        return 0;
      }

      return ((this.gerberCuttingCompleteGarments / this.statisticsTotalGarments) * 100).toFixed(1);
    },
    regionBreakdown() {
      const grouped = this.filteredOrders.reduce((acc, order) => {
        const region = order.Region || order.region || 'Unknown';

        if (!acc[region]) {
          acc[region] = {
            region,
            orders: 0,
            total_qty: 0,
            qty_printed: 0,
            qty_rolls: 0,
            qty_cut: 0,
          };
        }

        acc[region].orders += 1;
        acc[region].total_qty += order.total_qty || 0;
        acc[region].qty_printed += order.qty_printed || 0;
        acc[region].qty_rolls += order.qty_rolls || 0;
        acc[region].qty_cut += order.qty_cut || 0;

        return acc;
      }, {});

      return Object.values(grouped).sort((a, b) => a.region.localeCompare(b.region));
    },
    printLocationBreakdown() {
      const grouped = this.filteredOrders.reduce((acc, order) => {
        const printlocation = order.printlocation || 'Unknown';

        if (!acc[printlocation]) {
          acc[printlocation] = {
            printlocation,
            orders: 0,
            total_qty: 0,
            qty_printed: 0,
            qty_rolls: 0,
            qty_cut: 0,
          };
        }

        acc[printlocation].orders += 1;
        acc[printlocation].total_qty += order.total_qty || 0;
        acc[printlocation].qty_printed += order.qty_printed || 0;
        acc[printlocation].qty_rolls += order.qty_rolls || 0;
        acc[printlocation].qty_cut += order.qty_cut || 0;

        return acc;
      }, {});

      return Object.values(grouped).sort((a, b) => a.printlocation.localeCompare(b.printlocation));
    },
    workInProgressBreakdown() {
      const grouped = this.filteredOrders
        .filter((order) => this.isMakeupTrue(order))
        .reduce((acc, order) => {
          const makeuplocation = order.makeuplocation || 'Unknown';

          if (!acc[makeuplocation]) {
            acc[makeuplocation] = {
              makeuplocation,
              orders: 0,
              total_qty: 0,
              qty_received: 0,
              qty_on_factory_floor: 0,
              qty_off_factory_floor: 0,
            };
          }

          acc[makeuplocation].orders += 1;
          acc[makeuplocation].total_qty += order.total_qty || 0;
          acc[makeuplocation].qty_received += Number(order.qty_received || 0);
          acc[makeuplocation].qty_on_factory_floor += Number(order.qty_on_factory_floor || 0);
          acc[makeuplocation].qty_off_factory_floor += Number(order.qty_off_factory_floor || 0);

          return acc;
        }, {});

      return Object.values(grouped).sort((a, b) => a.makeuplocation.localeCompare(b.makeuplocation));
    },
    filteredOrders() {
      return this.orders.filter((order) => {
        const rangeMatch =
          this.filterRanges.length === 0 ||
          this.filterRanges.includes(order.range);
        const order_typeMatch =
          this.filterorder_types.length === 0 ||
          this.filterorder_types.includes(order.order_type);
        const locationMatch =
          this.filterLocations.length === 0 ||
          this.filterLocations.includes(order.makeuplocation);
        const printLocationMatch =
          this.filterPrintLocations.length === 0 ||
          this.filterPrintLocations.includes(order.printlocation);
        const artworkValue = (order.artwork || order.Artwork || '').toString().trim();
        const normalizedArtwork = artworkValue
          ? artworkValue.charAt(0).toUpperCase() + artworkValue.slice(1).toLowerCase()
          : '';
        const artworkMatch =
          this.filterArtworks.length === 0 ||
          this.filterArtworks.includes(normalizedArtwork);
        const makeupValue = (order.makeup || order.Makeup || '').toString().trim();
        const normalizedMakeup = makeupValue
          ? makeupValue.charAt(0).toUpperCase() + makeupValue.slice(1).toLowerCase()
          : '';
        const makeupMatch =
          this.filterMakeups.length === 0 ||
          this.filterMakeups.includes(normalizedMakeup);

        return rangeMatch && order_typeMatch && locationMatch && printLocationMatch && artworkMatch && makeupMatch;
      });
    },
  },
  mounted() {
    // Component mounted
  },
};
</script>

<style scoped>
.table-container {
  overflow-x: auto;
}

.section {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.tag.is-clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.tag.is-clickable:hover {
  transform: scale(1.05);
}
</style>